import { Component, HostListener, Inject } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-json-paste-dialog',
    templateUrl: './json-paste-dialog.component.html',
    styleUrls: ['./json-paste-dialog.component.css'],
    standalone: false
})
export class JsonPasteDialogComponent {
  jsonText: string = '';
  inputType: 'text' | 'json' = 'text';   // default selection
  error: string = '';

  constructor(
    private dialogRef: MatDialogRef<JsonPasteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data?.inputType) {
      this.inputType = data.inputType;   // set default (json/text)
    }
  }
  @HostListener('document:keydown.escape')
  onEscapePress() {
    this.dialogRef.close();
  }
  
  submit() {
    this.error = '';
    if (this.inputType === 'json') {
      // validate JSON
      try {
        const parsed = JSON.parse(this.jsonText);
        this.dialogRef.close(parsed);
      } catch {
        this.error = "Invalid JSON. Please check formatting.";
      }
    } 
    else {
      // return text as plain string
      const text = this.jsonText.trim();

      if (!text) {
        this.error = "Text cannot be empty.";
        return;
      }
      this.dialogRef.close(text);
    }
  }
}
